import React, { useEffect, useState, Fragment } from 'react';
import services from '../service';
import { Pagination, PageHeader, paginate } from '../../../Common';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { validateProperty, validate } from "../../Common"
import { CommonOperationCardSchemaObject } from '../commonOperationSchema';
import Joi from '@hapi/joi'
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { LoadingMaterialTable } from "../../../Common/table";
import DynamicFeedOutlinedIcon from '@material-ui/icons/DynamicFeedOutlined';

const screenCode = 'COMMONOPERATIONCARD'

export function CommonOperationCardListing(props) {

    const [operationCards, setoperationCards] = useState([]);
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [isTableHide, setIsTableHide] = useState([true]);
    const [searchFilter, setSearchFilter] = useState({
        groupID: '0',
        operationEntityId: '0',
        collectionPointId: '0'
    });
    const schema = Joi.object(CommonOperationCardSchemaObject).options({ allowUnknown: true });
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [searchFilter.groupID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointIDForDropdown()
        )

        if (searchFilter.operationEntityId != '0') {
            handleSearch();
        }
    }, [searchFilter.operationEntityId]);



    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }
    async function getOperationEntitiesForDropdown() {
        const operationEntity = await services.getAllOperationEntitiesForDropDown(searchFilter.groupID);
        setOperationEntity(operationEntity);
    }
    async function getCollectionPointIDForDropdown() {
        const collectionPoint = await services.GetCollectionPointsFilter(searchFilter.operationEntityId);
        setCollectionPoint(collectionPoint);
    }
    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCOMMONOPERATIONCARD');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITCOMMONOPERATIONCARD');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchFilter({
            ...searchFilter,
            groupID: token.groupID,
            operationEntityId: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropdown()
        )
    }

    function handleClick(operationCard) {
        props.history.push({
            pathname: 'commonoperationcard/addEdit',
            data: operationCard,
            edit: true
        })

    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchFilter({
            groupID: target.value,
            operationEntityId: '0',
            collectionPointId: '0'
        });
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);

        setSearchFilter({
            ...searchFilter,
            operationEntityId: target.value,
            collectionPointId: '0'
        });
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);

        setSearchFilter({
            ...searchFilter,
            collectionPointId: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors }
        const errorMessage = validateProperty(target, CommonOperationCardSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setErrors(error)
    }


    async function handleSearch(e) {

        if (e !== undefined) {
            const errorMessages = validate(schema, searchFilter)
            errorMessages !== null ? setErrors(errorMessages) : setErrors({})
            if (errorMessages) return;
        }

        const response = await services.getOperationCardsFilter(searchFilter);
        if (response.data == null || response.data == undefined) {
            setIsTableHide(true)
        }
        else {
            setIsTableHide(false);
            setoperationCards(response.data);
        }

    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Common Operation Cards"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Operation Card"
                            path="commonoperationcard/addEdit" />

                        <div className="card-body">

                            <form>
                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={searchFilter.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="operationEntityId">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityId"
                                            name="operationEntityId"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={searchFilter.operationEntityId}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select operation entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityId"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityId"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="collectionPointId">Collection Point </InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointId"
                                            name="collectionPointId"
                                            value={searchFilter.collectionPointId}
                                            onChange={(e) => handleCollectionPointChange(e.target)}>
                                            <MenuItem value="0">--Select Collectionpoint--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointId"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointId"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input

                                        type="button"
                                        onClick={(e) => {
                                            trackPromise(
                                                handleSearch(e)
                                            )
                                        }}
                                        className="btn btn-primary"
                                        value="Search"
                                    />

                                </div>
                            </form>

                            <div className="table-responsive row-top-gap" hidden={isTableHide}>

                                <LoadingMaterialTable
                                    title=""
                                    columns={[

                                        {
                                            title: "Card Number", field: "cardNumber",
                                            cellStyle: {
                                                width: 200,
                                                maxWidth: 200,
                                                textAlign: "center"
                                            },
                                            headerStyle: {
                                                width: 20,
                                                maxWidth: 20,
                                                whiteSpace: 'nowrap',
                                                textAlign: "center"

                                            }
                                        },

                                        {
                                            title: "Name to be Printed", field: "nameToBePrinted",
                                            cellStyle: {
                                                width: 200,
                                                maxWidth: 200,
                                                textAlign: "center"
                                            },
                                            headerStyle: {
                                                width: 20,
                                                maxWidth: 20,
                                                whiteSpace: 'nowrap',
                                                textAlign: "center"

                                            }
                                        },
                                        {
                                            title: "View ", field: "firstName",
                                            cellStyle: {
                                                width: 200,
                                                maxWidth: 200,
                                                textAlign: "center"
                                            },
                                            headerStyle: {
                                                width: 20,
                                                maxWidth: 20,
                                                whiteSpace: 'nowrap',
                                                textAlign: "center"

                                            },
                                            render: (data) => (
                                                <DynamicFeedOutlinedIcon
                                                    onClick={() => handleClick(data)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {" "}
                                                </DynamicFeedOutlinedIcon>
                                            )
                                        },
                                    ]}
                                    data={operationCards}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}